import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_CASH_REGISTER](state, payload) {
    state.cashRegister = payload;
  },
  [MutationsType.SET_CASH_REGISTERS](state, payload) {
    state.cashRegisters = payload;
  },
  [MutationsType.ADD_CASH_REGISTER](state, payload) {
    if (state.cashRegisters) state.cashRegisters.unshift(payload);
  },
  [MutationsType.UPDATE_CASH_REGISTER](state, payload) {
    let ind = (state.cashRegisters || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.cashRegisters, ind, payload);

    if (state.cashRegister?.id === payload.id) state.cashRegister = { ...state.cashRegister, ...payload };
  },
  [MutationsType.DELETE_CASH_REGISTER](state, payload) {
    let ind = (state.cashRegisters || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.cashRegisters, ind);
  },
  [MutationsType.SET_CASH_REGISTER_ORDERS](state, payload) {
    state.orders = payload;
  },
  [MutationsType.SET_CASH_REGISTER_ORDERS_CANCELED](state, payload) {
    state.ordersCanceled = payload;
  },
  [MutationsType.DELETE_CASH_REGISTER_ORDER](state, payload) {
    let ind = (state.orders || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.orders, ind);
  },
  [MutationsType.ADD_CASH_REGISTER_ORDER_CANCELED](state, payload) {
    state.ordersCanceled.unshift(payload);
  },
  [MutationsType.SET_CASH_REGISTER_REPORT_PRODUCTS](state, payload) {
    state.reportProducts = payload;
  },
  [MutationsType.SET_CASH_REGISTER_REPORT_TOTALS](state, payload) {
    state.reportTotals = payload;
  },
  [MutationsType.SET_CASH_REGISTER_REPORT_CLOSE](state, payload) {
    state.reportClose = payload;
  },
  [MutationsType.SET_CASH_REGISTER_PAYMENT_METHODS](state, payload) {
    state.paymentMethods = payload;
  },
  [MutationsType.SET_CASH_REGISTER_SHIFT](state, payload) {
    state.shift = payload;
  },
};
